export class ZohoPageInfo {
    per_page: number;
    count: number;
    page:number;
    more_records:boolean;
}
